<template>
    <ion-header ref="mapModalHeader">
        <ion-toolbar>
            <ion-buttons slot="start"></ion-buttons>
            <ion-title slot="secondary">Mappa</ion-title>
            <ion-buttons slot="end">
                <ion-button color="medium" @click="closeMap">Chiudi</ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content ref="mapModalContent" class="">
        <map-box
            :fix-zoom="fixZoom"
            :max-zoom="maxZoom"
            :height="height"
            border-radius="0"
            :center="center"
            :markers-data="markersData"
            :disable-interactions="disableInteractions"
            @tap="onTap"></map-box>
    </ion-content>
</template>

<script lang="ts" setup>
import { IonContent, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, modalController } from "@ionic/vue";
import { onMounted, PropType } from "vue";
import { ref } from "vue";
import { IExtendedMarkerOptions } from "@/types/maps";
import MapBox from "@/components/MapBox.vue";

const props = defineProps({
    fixZoom: {
        type: Number,
        required: false,
    },
    maxZoom: {
        type: Number,
        required: false,
    },
    borderRadius: {
        type: String,
        required: false,
        default: "8px",
    },
    center: {
        type: Object as PropType<google.maps.LatLngLiteral>,
        required: false,
    },
    markersData: {
        type: Array as PropType<IExtendedMarkerOptions[]>,
        required: false,
    },
    disableInteractions: {
        type: Boolean,
        required: false,
        default: true,
    },
    onTap: {
        type: Function as PropType<() => void>,
        required: false,
    },
});
const mapModalContent = ref<InstanceType<typeof IonContent> | null>(null);
const height = ref("300px");

const closeMap = () => {
    modalController.dismiss();
};

onMounted(() => {
    if (mapModalContent.value) {
        window.setTimeout(() => {
            const contentHeight = mapModalContent.value!.$el.offsetHeight;
            height.value = contentHeight + "px";
        }, 1000);
    }
});
</script>
